import Swal from 'sweetalert2';
import { userController } from 'lib/user';

const { deleteRecord } = userController();

// `type` is the value sent to the API, so it stays in English — only its label is translated.
const actionLabels = {
    delete: 'eliminare',
    active: 'attivare',
    deactive: 'disattivare',
};

const handleConfirmation = (checked, type, title, text, url, onSuccess, onError) => {
    const selected = Object.keys(checked).filter((key) => checked[key] === true);
    const action = actionLabels[type] || type;
    // `title` is either a plain noun phrase or { one, many } so the caller controls agreement.
    const label = typeof title === 'object' && title !== null
        ? (selected.length > 1 ? title.many : title.one)
        : title;

    Swal.fire({
        title: 'Confermi di voler ' + action + ' ' + label + '?',
        text: text || "Questa azione non può essere annullata.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annulla',
        confirmButtonColor: '#d33',
        confirmButtonText: "Sì, " + action + (selected.length > 1 ? " (" + selected.length + ")" : ""),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await deleteRecord(url, { id: (selected.length <= 1 ? selected[0] : selected), type: type });
                    if (onSuccess) onSuccess(response);
                } catch (error) {
                    if (onError) onError(error);
                }
            }
    });
};

export default handleConfirmation;
